import React, { useEffect, useRef, useState } from "react";
import * as func from "../../../common/manipurCommon/FunctionCalls";
import * as api from "../../../common/manipurCommon/API";
import Utils from "../../../common/manipurCommon/Utils";
import ImageWithBasePath from "../../../../core/data/img/ImageWithBasePath";
import { Link, useLocation } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { usePermissions } from "../../../common/PermissionContext";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";

const Gender = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [name, setName] = useState("");
    const [status, setStatus] = useState("");
    const [genderId, setGenderId] = useState("");
    const [genderList, setGenderList] = useState<any>([]);
    const [searchInput, setSearchInput] = useState("");

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        fetchGenders();
    }, [])

    async function fetchGenders() {
        setIsLoading(true);
        const gndrResponse = await func.gender(null);
        setGenderList(Array.isArray(gndrResponse) ? gndrResponse : [])
        setIsLoading(false);
    }

    const filteredData = genderList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const genderNameRender = (rowData) => {
        return <span>{rowData.name}</span>
    };

    const statusRender = (rowData) => {
        return <span>{(rowData.status == 1) ? "Active" : "Inactive"}</span>
    };

    function newGender() {
        setIsEdit(false);
        setName("");
        setOpenModal(true);
    }

    const editDetails = (rowData: any) => {
        return (
            <Link to="#" onClick={() => editGender(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const ccId = rowData.id;

        return (
            <Link to="#" onClick={() => deleteGender(ccId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    async function editGender(rowData: { id: any; }) {
        const ccId = rowData.id;
        setIsEdit(true)
        setOpenModal(true)
        const getDetails = await func.gender(ccId);
        setGenderId(getDetails.id);
        setName(getDetails.name);
        setStatus(getDetails.status);
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateGender();
            } else {
                const formData = new FormData();
                formData.append("name", name);

                const gndr = api.Gender;
                fetch(gndr, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    // window.location.reload(); // 🔁 Reload only after OK is clicked
                                    setOpenModal(false);
                                    fetchGenders();
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            })
                        }
                    })
            }
        }
    }

    function updateGender() {
        const formData = new FormData();
        formData.append("name", name);
        formData.append("status", status);
        const updateCompFrmt = api.Gender + '/' + genderId;
        fetch(updateCompFrmt, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setIsEdit(false);
                            setOpenModal(false);
                            fetchGenders();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    function deleteGender(gndrId: string) {
        const delCompFrmt = api.Gender + '/' + gndrId + '/0';
        fetch(delCompFrmt, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setOpenModal(false);
                            fetchGenders();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Genders</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newGender() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Gender">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>

                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="name"
                                                header="Gender"
                                                body={genderNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="status"
                                                header="Status"
                                                body={statusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {currentPermissions.includes("edit") ?
                                                <Column
                                                    className="text-link"
                                                    body={editDetails}
                                                ></Column>
                                                : null
                                            }
                                            {currentPermissions.includes("delete") ?
                                                <Column
                                                    className="text-link"
                                                    body={deleteDetails}
                                                ></Column>
                                                : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={openModal}
                onHide={() => setOpenModal(false)}
                backdrop="static"
                keyboard={false}
                centered
            >
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Gender</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="col-lg-12 mb-10">
                            <div className="input-space">
                                <label className="form-label">Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={name}
                                    onChange={(e) => {
                                        setName(e.target.value);
                                    }}
                                    style={{ height: "40px", padding: "17px" }}
                                    placeholder="Enter Name"
                                    required
                                />
                            </div>
                        </div>
                        {isEdit ?
                            <>
                                <div className="col-lg-12 mt-10">
                                    <div className="row">
                                        <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                            <label className="form-label">Status</label>
                                        </div>
                                        <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                            <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                <input
                                                    className="form-check-input text-end"
                                                    type="checkbox"
                                                    checked={status === '1'}
                                                    id="status"
                                                    onChange={(e) => {
                                                        setStatus(e.target.checked ? '1' : '0')
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </> : null
                        }
                        <ModalFooter>
                            <Button
                                className="btn-primary text-uppercase"
                                variant="success"
                                type="submit"
                                onClick={handleSubmit}
                            >
                                <b><i className="fas fa-save" />Save</b>
                            </Button>
                        </ModalFooter>
                    </form>
                </ModalBody>
            </Modal>
        </>
    );
};

export default Gender;